import type { oz } from '@weft/utils';
import { isNotNullOrUndefined } from '@weft/utils';
import { UsagePricingSchema } from './usage-pricing-schema';

export function withUsageProductMeterIdValidation(
  schema: oz.ZodTypeAny,
) {
  return schema.refine((variant) => {
    const { success: isUsageVariant } = UsagePricingSchema.safeParse(variant.pricing);

    return !isUsageVariant || isNotNullOrUndefined(variant.meterId);
  }, {
    message: 'Meter ID is required for usage products',
  });
}